import { render, staticRenderFns } from "./KnowledgeUnitOptionMedia.vue?vue&type=template&id=b635ee92&"
import script from "./KnowledgeUnitOptionMedia.vue?vue&type=script&lang=js&"
export * from "./KnowledgeUnitOptionMedia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports